// i18n area 'storage' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.ro-RO.meta.json.
import type { enUS } from './storage'

export const roRO: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Creează storage',
      path: 'Cale',
      pathHint: 'Cale absolută sub un root permis (implicit /var/lib/tvirt/pools/)',
      shared: 'Storage partajat',
      sharedChip: 'partajat',
      sharedVerifiedChip: 'partajat · verificat',
      sharedVerifiedTooltip: 'Partajare verificată: sondele încrucișate confirmă că fiecare membru vede datele scrise de ceilalți.',
      sharedDisputedChip: 'partajat · NEVERIFICAT',
      sharedDisputedTooltip: 'Partajarea NU este verificată',
      sharedDisputedPair: '{observer} nu vede datele scrise de {writer}',
      sharedHint: 'Un share de rețea montat local pe aceeași cale pe fiecare membru — precondiția migrării live (declarativ).',
      sharedDanger: 'PERICOL — TVirt CREDE acest flag: odată aprins, fiecare membru presupune că vede ACEIAȘI octeți la acest path. Pe un folder care NU este un share cu adevărat partajat (NFS/CIFS/sistem de fișiere de cluster), rezultatul este coruperea și pierderea datelor la prima migrare sau la prima repornire HA pe alt nod. Aprinde-l doar dacă path-ul este un share montat identic pe fiecare nod.',
      type: 'Tip',
      capacity: 'Capacitate',
      provisioned: 'Alocat',
      provisionedOvercommit: 'Angajament potențial peste capacitate: volumele thin pot crește până la {n} GiB.',
      phase: { ready: 'Gata', degraded: 'Degradat', error: 'Eroare' },
      tabConfig: 'Configurare',
      tabCapacity: 'Capacitate și stare',
      cardIdentity: 'Identitate',
      cardPlacement: 'Plasare',
      cardConnection: 'Conexiune',
      usedReal: 'Utilizare reală',
      capacityUnknown: 'Nodul nu a raportat încă capacitatea acestui pool — aici nu se inventează numere',
      overcommitHint: 'Angajament peste capacitate: legitim pe pool-urile thin, fii atent la utilizarea reală',
      supportedContent: 'Conținuturi suportate',
      content: {
        disks: 'Discuri',
        catalogFiles: 'Fișiere de catalog',
        backups: 'Backupuri',
        appVolumes: 'Volume de aplicații'
      },
      defaultDiskFormat: 'Format de disc implicit',
      reserveGiB: 'Spațiu liber rezervat (GiB)',
      available: 'Disponibil',
      diskCount: 'Discuri',
      filesystem: 'Sistem de fișiere',
      observedAt: 'Observat la',
      lostAtRow: 'Declarat pierdut la',
      sharedProbeRow: 'Verificarea partajării',
      sharedProbeNodes: 'Noduri sondate',
      reachableFrom: 'Accesibilitate declarată',
      reachableFromHint: 'Nodurile din care acest storage trebuie să fie accesibil. O VM cu discuri, ISO-uri sau metadate aici nu pornește și nici nu migrează pe un nod din afara acestei liste. Toți membrii sunt preselectați: restrânge după cum vrei. Un nod care intră în cluster mai târziu rămâne pe dinafară până când îl adaugi aici.',
      reachableFromNone: 'nedeclarată',
      reachableFromTags: 'Accesibilitate prin taguri',
      reachableFromTagsHint: 'Selector tag=valoare (intrări separate prin virgulă, în AND): fiecare membru care poartă aceste taguri este declarat accesibil — dinamic: pui un tag pe un nod și el intră.',
      reachableFromTagsInvalid: 'Format invalid — folosește tag=valoare, separate prin virgulă',
      reachableResolved: 'Noduri rezolvate: {nodes}',
      reachableDeclaredNotSeen: 'declarat, dar nevăzut de sonda de partajare pe: {nodes}',
      reachableSeenNotDeclared: 'văzut, dar nedeclarat (în afara perimetrului) pe: {nodes}',
      cephCluster: 'Cluster Ceph gestionat',
      appGuardTitle: 'Storage folosit de aplicații',
      appEphemeralGuard: 'acest storage este pool-ul efemer de cluster al aplicațiilor — schimbă-l mai întâi din pagina Aplicații, apoi șterge-l.',
      appInUseGuard: 'aici trăiesc root-uri/volume de aplicații: {apps} — mută-le sau șterge-le mai întâi.',
      releaseRequiredTitle: "Ștergi '{name}' și eliberezi imaginile sale?",
      releaseRequiredBatchTitle: 'Ștergi storage-urile selectate și eliberezi imaginile lor?',
      releaseRequiredBody: 'Eliberarea imaginilor nu șterge NICIUN octet: dez-înregistrarea lasă namespace-ul pe disc, imaginile pur și simplu nu mai sunt materializate, iar fiecare referință a scope-urilor supraviețuiește ca și claim — înregistrează din nou pool-ul și sunt readoptate.',
      releaseConfirm: 'Șterge și eliberează imaginile'
    },
    lost: {
      chip: 'Pierdut',
      action: 'Declară pierdut',
      confirmTitle: 'Declară storage-ul pierdut',
      confirmBody: 'Atestare a operatorului pe propriul risc declarat: fiecare task în coadă sau în curs pe acest storage sau pe obiectele lui va EȘUA, ștergerile devin doar de registru (nicio lucrare pe sistemul de fișiere), iar lucrul fizic nou este refuzat. Octeții nu sunt atinși niciodată — dacă volumul revine la viață, înregistrează-l din nou și rulează un scan ca să re-adopți totul.',
      confirmSubmit: 'Declară pierdut',
      error: 'Atestarea a fost refuzată'
    },
    findings: {
      action: 'Obiecte găsite',
      title: 'Obiecte găsite',
      empty: 'Niciun obiect găsit în namespace-ul storage-ului',
      loadError: 'Obiectele găsite nu au putut fi încărcate',
      actionError: 'Decizia a fost refuzată',
      colKind: 'Tip',
      colObject: 'Obiect',
      colConflict: 'Conflict',
      namespaceNotice:
        'Acest director fusese deja inițializat de un alt storage: sigiliul de identitate a fost rescris cu cel al acestui storage. Conținutul NU a fost atins — uită-te la obiectele găsite mai jos, importă-le pe cele de care ai nevoie, apoi respinge această notificare.',
      kind: {
        disk: 'Disc',
        catalogFile: 'Fișier de catalog',
        vmMetadata: 'Metadate VM',
        namespace: 'Namespace',
        foreign: 'Străin',
        volumeGroup: 'Grup de volume'
      },
      vgAdopt: {
        action: 'Adoptă grupul de volume',
        title: 'Adoptă grupul de volume',
        intro:
          'Acest dispozitiv poartă deja un grup de volume cu un nume de TVirt, dar sigiliul lui nu numește niciun storage înregistrat aici. Poate fi ceea ce un storage anterior al ACESTUI cluster a lăsat pe LUN — sau ceea ce ALT cluster TVirt a lăsat pe un LUN care și-a schimbat stăpânul: de aici cele două cazuri arată identic, și de aceea nimeni nu decide în locul tău.',
        irreversible: 'Uită-te la dispozitiv, la sigiliu și la nume înainte de a continua: adopția nu se anulează.',
        device: 'Dispozitiv',
        seal: 'Sigiliu',
        sealNone: 'niciunul (fără etichetă tvirt.storageId)',
        renameTo: 'Va fi redenumit în',
        renameNone: 'Fără redenumire: numele este deja cel pe care acest storage îl derivă',
        volumesNote:
          'Volumele conținute NU sunt adoptate prin acest gest: următoarea scanare le oferă unul câte unul, ca obiecte găsite obișnuite.'
      },
      conflictChip: 'ID deja existent',
      dismissedChip: 'Ignorat',
      adopt: 'Adoptă',
      adoptFileTitle: 'Importă într-un catalog',
      adoptFileHint: 'Fișierele există doar în cataloage: alege catalogul de destinație pentru fișierul găsit.',
      purge: 'Șterge de pe disc',
      dismiss: 'Ignoră',
      purgeConfirmTitle: 'Șterge de pe disc',
      purgeConfirmBody: 'Octeții găsiți ai lui {id} vor fi eliminați de pe storage. Operațiunea nu este reversibilă.',
      taskStarted: 'Pornit — continuă ca task în background',
      scan: 'Scanează storage-ul',
      scanStarted: 'Scanare pornită…',
      scanDone: 'Scanare încheiată — obiectele găsite sunt la zi'
    },
    reinit: {
      action: 'Reîncearcă inițializarea'
    },
    wizard: {
      addButton: 'Adaugă',
      title: 'Adaugă storage',
      back: 'Înapoi',
      continue: 'Continuă',
      selectHint: 'Selectează un protocol ca să vezi cum îl folosește TVirt.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Cale exportată',
      share: 'Share',
      username: 'Nume de utilizator',
      password: 'Parolă',
      passwordHint: 'Doar scriere: folosită pentru mount, nu se mai arată niciodată.',
      credential: 'Credențială',
      credentialManual: 'Introdu manual',
      credentialHint: 'O intrare din keystore de tip username și password — alternativa la a le tasta aici.',
      credentialEmpty: 'Nicio credențială de tip username și password în keystore — creeaz-o în Sistem → Credențiale, sau tastează contul mai jos.',
      options: 'Opțiuni de mount',
      optionsHint: 'Separate prin virgulă, transmise lui mount -o ca atare.',
      portal: 'Portal',
      portalHint: 'host[:port] — portul implicit este 3260.',
      target: 'Target IQN',
      targetHint: 'Numele targetului iSCSI, începe cu iqn.',
      lun: 'LUN',
      wholeLunRow: 'Pe discuri: acest storage numește doar target-ul',
      wholeLunHint: 'Acest storage numește doar target-ul: LUN-urile lui devin discuri unul câte unul (Creează disc → adoptă un LUN întreg), pe target nu se scrie nimic.',
      lunHint: 'Numărul LUN-ului pe target — 0 în caz de dubiu.',
      chapCredential: 'Credențială (CHAP)',
      chapCredentialHint: 'O intrare din keystore de tip CHAP (iSCSI) folosită la conectare — secretul nu călătorește niciodată cu storage-ul.',
      chapNone: 'Fără autentificare',
      chapEmpty: 'Nicio credențială de tip CHAP (iSCSI) în keystore — creeaz-o în Sistem → Credențiale. Fără ea, conectarea rămâne neautentificată.',
      address: 'Adresă',
      addressHint: 'Hostul sau IP-ul targetului NVMe/TCP (traddr).',
      port: 'Port',
      portHint: 'Portul TCP al targetului — 4420 dacă e lăsat gol.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN-ul subsystem-ului pe target, începe cu nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID în interiorul subsystem-ului — 1 în caz de dubiu.',
      dhchapCredential: 'Credențială (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'O intrare din keystore de tip DH-HMAC-CHAP (NVMe) folosită la conectare — secretul nu călătorește niciodată cu storage-ul.',
      dhchapNone: 'Fără autentificare',
      dhchapEmpty: 'Nicio credențială de tip DH-HMAC-CHAP (NVMe) în keystore — creeaz-o în Sistem → Credențiale. Fără ea, conexiunea rămâne neautentificată.',
      monitors: 'Monitoare',
      monitorsHint: 'Endpoint-urile monitoarelor Ceph, host[:port], separate prin virgulă sau pe linii noi — portul implicit este 6789.',
      pool: 'Pool',
      poolHint: 'Pool-ul RBD de consumat — o imagine RBD per disc.',
      fs: 'Sistem de fișiere',
      fsHint: 'Numele sistemului de fișiere CephFS (mds_namespace la mount).',
      fsPath: 'Path în interiorul sistemului de fișiere',
      fsPathHint: 'Path absolut în interiorul sistemului de fișiere pe care storage-ul îl montează — / în caz de dubiu.',
      cephxCredential: 'Credențială (cephx)',
      cephxCredentialHint: 'O intrare din keystore de tip cephx: username = numele clientului (client.…), secret = cheia base64. Obligatorie.',
      cephxNone: 'Nicio credențială cephx în keystore — creează una (tip: cephx) în Sistem → Credențiale, sau lasă un cluster Ceph gestionat s-o emită prin „Propune ca storage”.',
      sharedByNature: 'Storage-urile de rețea sunt partajate prin natura lor: fiecare membru le montează pe aceeași cale gestionată de TVirt.',
      error: 'Storage-ul a fost refuzat',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Altele',
        legacy: 'Legacy'
      },
      legacyHint: 'Suportate pe deplin — doar că nu le-am alege pentru o instalare nouă.',
      proto: {
        dir: {
          name: 'Folder local',
          desc: 'Un director al nodului: simplu și rapid. Este LOCAL unui singur nod, dacă path-ul nu e un share cu adevărat partajat — a-l marca partajat când nu este costă date.',
          usage: 'TVirt păstrează în el discuri ale VM-urilor, imagini ISO/disc și template-uri.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Un export NFS montat de cluster — partajat prin natura lui.',
          usage: 'Găzduiește discuri ale VM-urilor, imagini ISO/disc și template-uri.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Un share Windows/Samba montat de cluster — partajat prin natura lui.',
          usage: 'Găzduiește discuri ale VM-urilor, imagini ISO/disc și template-uri.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Un sistem de fișiere remote prin SSH — fără nevoie de export NAS.',
          usage: 'În roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'LUN-uri bloc prin IP, cu LVM partajat deasupra.',
          usage: 'Doar discuri — un volum thin per disc; nu găzduiește imagini ISO și nici template-uri.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block device-uri distribuite pe un cluster Ceph.',
          usage: 'Doar discuri — o imagine RBD per disc, deschisă nativ de QEMU; nu găzduiește imagini ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Sistemul de fișiere distribuit al lui Ceph, montat de kernel pe cluster — shared by nature.',
          usage: 'Găzduiește discuri VM, imagini ISO/disc și template-uri — familia dir pe un sistem de fișiere Ceph (credențială cephx obligatorie).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN-uri SCSI pe fabric FibreChannel — SAN-ul FC clasic.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Același SCSI pe FibreChannel, cu frame-urile FC încapsulate în Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (LUN-uri întregi)',
          desc: 'Target-ul iSCSI ca purtător de LUN-uri întregi: fiecare disc ESTE un LUN, dat brut guest-ului — fără LVM la mijloc.',
          usage: 'Doar discuri — un LUN întreg per disc, adoptat așa cum este; casa SAN a discurilor cu scriere partajată.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (namespace-uri întregi)',
          desc: 'Subsistemul NVMe ca purtător de namespace-uri întregi: fiecare disc ESTE un namespace, dat brut guest-ului.',
          usage: 'Doar discuri — un namespace întreg per disc, adoptat așa cum este; scriere partajată da, persistent reservations SCSI nu.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'NVMe remote — fără SCSI pe traseu — pe TCP simplu, cu LVM partajat deasupra.',
          usage: 'Doar discuri — un volum thin per disc; nu găzduiește imagini ISO și nici template-uri.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'NVMe remote pe fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe pe fabricul FibreChannel pe care FCoE îl transportă în Ethernet — straturile FCoE și NVMe/FC suprapuse.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI cu calea de date mutată pe RDMA — orice fabric (InfiniBand, iWARP, RoCE). Depășit de NVMe/RDMA, încă prezent în array-uri și în ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'SCSI nativ pe RDMA, era pre-iSER: InfiniBand (cu discovery de fabric) și RoCE — supraviețuiește în storage-urile HPC învechite.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'NVMe remote pe orice fabric RDMA — InfiniBand, iWARP, RoCE v1 și v2: o singură configurare, nodul spune pe care o are.' },
        s3: { name: 'S3', desc: 'Object storage compatibil S3 — imagini și backupuri.' }
      }
    },
    catalogs: {
      title: 'Cataloage',
      createTitle: 'Creează catalog',
      editTitle: 'Modifică catalogul',
      docTitle: 'Catalog',
      notFound: 'Acest catalog nu (mai?) există',
      scopeHint: 'Cine citește acest scope vede (și poate folosi) fiecare fișier din catalog',
      files: 'Fișiere',
      noFiles: 'Niciun fișier',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'de sistem',
      systemTooltip: 'Catalog de sistem: găzduiește obiectele integrate ale platformei și nu poate fi modificat'
    },
    catalogFiles: {
      catalog: 'Catalog',
      kindLabel: 'Tip',
      physicalSize: 'Dimensiune fizică',
      virtualSize: 'Dimensiune virtuală',
      importTemplateAction: 'Importă ca VM Template',
      importTemplateLegacy: 'Niciun format declarat — utilizabil ca seed pentru discuri, nu importabil',
      importTemplateTitle: 'Importă ca VM Template',
      importTemplateSubmit: 'Importă',
      importTemplateError: 'Importul a eșuat',
      importTemplateHint: 'Pachetul .tvtpl devine un VM Template: hardware-ul înghețat din manifest plus câte un disc pentru fiecare intrare din arhivă, fiecare verificat contra checksum-ului său. NIC-urile și mediile CD/DVD nu fac parte dintr-o arhivă — adaugă-le după import.',
      importTemplateQcow2Hint: 'Un qcow2 brut devine un template cu UN singur disc și hardware-ul implicit declarat: profil linux, UEFI, 2 vCPU, 2048 MiB, boot de pe singurul lui disc. Ajustează la implementare.',
      importTemplateName: 'Numele template-ului',
      importTemplateNameHint: 'Gol = {name} (-import-<n> dacă e ocupat)',
      importTemplateStorage: 'Storage pentru discuri',
      importTemplateMetadataStorage: 'Storage de metadate',
      importTemplateMetadataHint: 'Un storage bloc nu găzduiește metadatele VM (firmware, varstore) — alege unul dir/nfs/cifs.',
      importTemplateStarted: 'Import pornit — template-ul apare în fila Template la închiderea taskului.',
      kind: {
        iso: 'Imagine ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Template VM',
        'oci-image': 'Imagine OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Imagini ISO',
        'ct-rootfs': 'Template-uri CT',
        'vm-template': 'Template-uri VM',
        'oci-image': 'Imagini OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Adaugă imagine ISO',
        'ct-rootfs': 'Înregistrează template CT',
        'vm-template': 'Adaugă template VM',
        'oci-image': 'Adaugă imagine OCI',
        'firmware-ovmf': 'Adaugă firmware OVMF'
      },
      formatHint: 'Derivat din extensia fișierului ales — corectează-l dacă a ghicit greșit',
      tarballHint: 'Un tarball rootfs în formatul LXC standard (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, sau un .tar simplu)',
      ociArchiveHint: 'Un tarball docker-archive / oci-archive (.tar sau .tar.gz), de exemplu din docker save',
      uploadResumeHint: 'Upload întrerupt — fișierul așteaptă upload-ul: trimite din nou cu același fișier pentru a relua',
      moveTitle: 'Mută fișierul',
      moveHint: 'Două dimensiuni independente: Catalogul mută legătura (același id, niciun octet nu se mișcă, scope-ul devine cel al catalogului de destinație); Storage-ul mută datele — fiecare copie legată îl urmează, refuzat cât timp fișierul este în uz. Alese împreună: mai întâi catalogul, apoi storage-ul.',
      moveCatalog: 'Catalog de destinație',
      moveCatalogHint: 'Doar legătura își schimbă casa: o VM care montează fișierul trebuie să poată vedea catalogul de destinație',
      keepCurrent: 'Nu schimba',
      rehomed: 'Legătură mutată în catalogul ales',
      copyAction: 'Copiază într-un catalog…',
      copyTitle: 'Copiază într-un catalog',
      copyLinkHint: 'Copia este o legătură nouă către aceleași date — nimic nu se duplică pe storage.',
      copyCatalog: 'Catalog de destinație',
      copyCatalogHint: 'Copierea este felul în care un fișier călătorește între cataloage',
      sameCatalog: 'Același ca sursa',
      sharedObjectHint: 'Datele acestui fișier sunt partajate de copiile legate ({count})',
      deleteLastLink: 'Aceasta este ULTIMA legătură către acest conținut: datele vor fi șterse și de pe storage.',
      deleteLinkOnly: 'Va fi eliminată doar această legătură — datele rămân, încă accesibile prin celelalte copii legate ({count}).',
      noCatalog: 'Nu există niciun catalog — creează unul',
      inlineCatalogName: 'Numele catalogului',
      embeddedChip: 'integrat',
      embeddedStorage: 'Integrat în platformă',
      embeddedNoMove: 'Fișier integrat al platformei: nu trăiește pe niciun storage — clonează-l în schimb',
      embeddedCopyHint: 'Clona materializează octeții integrați pe un storage adevărat: alege storage-ul și catalogul de destinație — copia este un fișier obișnuit',
      sourceEmbedded: 'Integrat în platformă',
      nodesRow: 'Prezență per nod',
      nodesSummary: '{present} din {total} noduri îl au',
      nodePresent: 'prezent',
      nodeMissing: 'lipsește',
      nodeUnknown: 'încă neraportat',
      nodesHint: 'Asset-ul trăiește pe discul fiecărui nod (pachetul trantor-tvirt-assets): un nod care nu îl are nu poate nici defini o VM cu acest firmware, nici servi Guest Tools. Versiuni diferite între noduri sunt normale în timpul unei actualizări progresive.',
      downloadAction: 'Descarcă',
      downloadNotReady: 'Conținutul nu este încă gata — descărcarea cere un fișier ready',
      downloadDenied: 'Rolul tău nu include catalog.download — descărcarea octeților este un drept separat de folosirea fișierului',
      objectRow: 'Obiect storage',
      objectLinksRow: 'Copii legate',
      declaredChecksum: 'SHA-256 declarat',
      usedByRow: 'Folosit de',
      usedByVms: 'VM-uri',
      usedByDisks: 'Discuri',
      transferRow: 'Transfer',
      storageLockHint: 'Se schimbă doar prin acțiunea Mută'
    },
    objects: {
      action: 'Explorează conținutul',
      title: 'Conținutul storage-ului',
      hint: 'Inventar doar în citire a ceea ce trăiește pe acest storage — fiecare obiect se gestionează din secțiunea lui.',
      empty: 'Nimic înregistrat pe acest storage',
      loadError: 'Conținutul nu a putut fi încărcat',
      colDetail: 'Detaliu',
      manage: 'Gestionează în secțiunea lui',
      kind: {
        disk: 'Disc',
        catalogFile: 'Fișier de catalog',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadate VM',
        appRoot: 'Root de aplicație',
        appVolume: 'Volum de aplicație'
      }
    },
    inventory: {
      tabCatalogs: 'Cataloage',
      storage: 'Storage',
      sizeGib: 'Dimensiune (GiB)',
      format: 'Format',
      size: 'Dimensiune',
      sourceType: 'Sursă',
      sourceFile: 'Încărcare de fișier',
      sourceUrl: 'Download de la URL',
      file: 'Fișier',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Obligatoriu: descărcarea este verificată contra acestui SHA-256',
      verifyChecksum: 'Verifică checksum-ul',
      checksumOffHint: 'Descărcarea va fi acceptată fără verificare — SHA-256-ul calculat este oricum înregistrat',
      uploading: 'Se încarcă…',
      move: {
        action: 'Mută',
        diskTitle: 'Mută discul',
        target: 'Storage de destinație',
        diskHint: 'Discul își păstrează identitatea: octeții călătoresc pe storage-ul ales. O VM care îl folosește trebuie să fie stinsă; cu snapshoturi prezente, o parte iSCSI refuză mutarea.',
        noTargets: 'Niciun storage de destinație compatibil',
        submit: 'Mută',
        error: 'Mutarea a fost refuzată'
      },
      clone: {
        action: 'Clonează',
        title: 'Clonează discul',
        name: 'Numele copiei',
        storage: 'Storage de destinație',
        sameStorage: 'Același ca sursa',
        linked: 'Linked clone',
        linkedHint: 'Overlay qcow2 instantaneu, înlănțuit de discul sursă (doar surse qcow2). Implicit se face o copie completă.',
        linkedCrossHint: 'Un linked clone rămâne pe storage-ul sursei: alege „Același ca sursa” pentru a-l activa.',
        submit: 'Clonează',
        error: 'Clonarea a fost refuzată'
      },
      copy: {
        action: 'Copiază',
        name: 'Numele copiei',
        storage: 'Storage de destinație',
        sameStorage: 'Același ca sursa',
        submit: 'Copiază',
        error: 'Copierea a fost refuzată'
      },
      taskStarted: 'Pornit — continuă ca task în background',
      cephObjects: 'Mergi la detaliile obiectului pe Ceph',
      phase: {
        ready: 'Gata',
        creating: 'Se creează',
        'awaiting-upload': 'Așteaptă upload-ul',
        downloading: 'Se descarcă',
        verifying: 'Se verifică',
        deleting: 'Se șterge',
        error: 'Eroare',
        'in-use': 'În uz'
      }
    }
  }
}
